function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 975.579,
  cy: 811.059,
  rx: 144.421,
  ry: 18.742,
  fill: "#3f3d56"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M0 27.5h436v272H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M27.5 1h436v272h-436z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M312.468 202.968A94 94 0 00246 42.5v94z",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M246 42.5a94.011 94.011 0 00-44.968 176.564L246 136.5z",
  fill: "#ffd005"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M312.468 202.968L246 136.5l-44.968 82.564a94.05 94.05 0 00111.436-16.096z",
  fill: "#575a89"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd005",
  d: "M44 216.5h18v18H44z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M70 216.5h18v18H70z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#575a89",
  d: "M96 216.5h18v18H96z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M355 220.5h74v3h-74zM355 229.5h74v3h-74zM355 238.5h74v3h-74z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M137 406.5h248v272H137z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M162 380.5h248v272H162z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd005",
  d: "M175 621.814h13.371v13.371H175z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M194.314 621.814h13.371v13.371h-13.371z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#575a89",
  d: "M213.629 621.814H227v13.371h-13.371z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M325 627.622h52v2.108h-52zM325 633.946h52v2.108h-52zM325 640.27h52v2.108h-52zM286 428.5v22a66 66 0 0146.67 112.67l15.555 15.555A88 88 0 00286 428.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M348.225 578.725L332.67 563.17a65.983 65.983 0 01-86.6 5.872l-13.316 17.52a87.998 87.998 0 00115.472-7.836z",
  fill: "#575a89"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M220 516.5a66 66 0 0166-66v-22a88 88 0 00-53.247 158.061l13.316-17.52A65.885 65.885 0 01220 516.5z",
  fill: "#ffd005"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M931.624 140.993s-4.08 30.31 6.412 33.808 7.578 30.31 7.578 30.31l-31.476 23.9-27.98 2.331-6.994-36.14 4.08-9.326s15.738-18.652 4.663-37.888 43.717-6.995 43.717-6.995z",
  fill: "#ffb9b9"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M931.624 140.993s-4.08 30.31 6.412 33.808 7.578 30.31 7.578 30.31l-31.476 23.9-27.98 2.331-6.994-36.14 4.08-9.326s15.738-18.652 4.663-37.888 43.717-6.995 43.717-6.995z",
  opacity: 0.1
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M902.48 377.066l-36.723 86.269s-28.562-16.321-45.466-14.572-37.888-18.653-37.888-18.653l20.984-101.424 39.054-107.836 54.21 34.391z",
  fill: "#575a89"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M902.48 377.066l-36.723 86.269s-28.562-16.321-45.466-14.572-37.888-18.653-37.888-18.653l20.984-101.424 39.054-107.836 54.21 34.391z",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#575a89",
  d: "M960.186 743.708v27.979h-26.23l4.08-32.642 22.15 4.663zM1028.385 695.328l19.236 11.658-13.99 32.059-14.572-1.749-13.99-19.818 23.316-22.15z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M965.432 368.906l34.391 81.022s-12.24 89.766-11.658 97.344 1.166 10.492-1.748 16.904-4.08 10.492-2.332 18.07 2.332 10.492 1.166 13.407-9.326 122.99-13.407 131.151 2.332 21.567-1.748 22.733-34.391-1.748-36.14-8.743 5.829-23.899 1.749-29.145.583-194.105-5.246-206.928-69.948-24.482-69.948-24.482-5.829-37.305-2.332-43.134 8.161-42.552 8.161-42.552zM931.624 767.024s16.322-19.236 30.311 0c0 0 1.166 22.733 11.075 27.396s5.246 23.316-8.743 23.899-32.06 2.914-32.643-4.663 2.332-12.241-2.914-14.573 0-15.738 0-15.738z",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M933.373 488.4s-.583 41.968-4.663 47.797-6.412 9.326-4.08 15.738 5.829 18.07 4.08 20.402 1.749 14.572 1.749 14.572 44.883 21.567 65.867 66.45c0 0 21.567 35.557 27.979 36.14s13.99-4.08 10.492 9.326-16.904 30.894-26.813 29.145-17.487-18.653-17.487-18.653-77.525-78.69-85.686-81.022-31.476-20.985-35.556-32.642-12.824-109.002-8.744-115.414 19.236-15.155 19.236-15.155z",
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1034.214 692.996s36.14 1.166 36.723 9.91-15.156 60.62-12.824 72.862-18.07 40.22-31.476 34.39-2.915-36.14-2.915-36.14-13.407-41.385-11.075-41.968 25.647-7.577 24.482-14.572-2.915-24.482-2.915-24.482z",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 904.52,
  cy: 136.039,
  r: 36.14,
  fill: "#ffb9b9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M940.95 191.705s-19.818 20.985-34.39 17.487-22.15-28.562-22.15-28.562l-26.23-4.663s-18.653 82.771-18.653 90.932 18.652 96.178 18.652 111.916-15.155 25.065 8.161 24.482 12.24-8.16 46.049-8.744 39.054 6.995 46.049-5.246a97.523 97.523 0 0117.487-21.567l-12.241-43.134-1.749-121.826s-14.944-29.144-21.753-26.813c0 0 3.683 12.824.769 15.738z",
  fill: "#ffd005"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M933.771 170.812s31.079 3.406 39.822 9.818 33.225 11.075 32.642 15.738-28.562 71.114-28.562 71.114-12.823 52.46-1.748 64.701 52.46 145.724 45.465 156.8-29.144-33.809-29.144-33.809-29.728-96.177-46.05-112.499-17.486-104.338-17.486-108.418 5.061-63.445 5.061-63.445zM888.313 177.572s-38.294-14.429-51.7-8.6-21.568 6.995-21.568 6.995l-4.663 57.124s-1.749 82.188-16.904 102.007-25.065 102.59-22.733 110.75-4.08 22.15 5.829 18.653 37.305-83.937 37.305-83.937 0-46.05 16.321-58.873 43.135-65.867 44.3-78.69 12.241-48.381 12.241-48.381z",
  fill: "#575a89"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1019.642 361.328s-17.487 32.642-19.819 38.471-18.652 45.466-41.968 36.723 22.733-51.295 22.733-51.295l10.492-35.557s27.396-5.829 28.562 11.658z",
  fill: "#ffb9b9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M820.874 175.967h-5.829s-5.829-4.663-12.824-1.749-23.315-1.165-23.315.583-18.07-5.246-25.648-1.748-34.974 4.663-34.974 4.663-11.075 27.979-3.497 33.225 18.653 1.166 23.899 5.246 15.155-.583 18.652 4.663 16.321 14.573 19.236 8.744-2.915-11.075 9.326-4.664 31.477 6.412 31.477 6.412z",
  fill: "#575a89"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M907.778 109.337c-4.89-1.13-9.967.122-14.92.934s-10.413 1.08-14.602-1.684c-3.095-2.041-4.997-5.418-6.784-8.666a9.973 9.973 0 01-1.459-3.823c-.21-2.402 1.318-4.594 2.94-6.377 7.538-8.285 18.552-12.82 29.659-14.26 9.13-1.184 18.65-.391 27.081 3.307s15.68 10.47 18.995 19.06a54.127 54.127 0 012.836 13.61 40.657 40.657 0 01.192 10.309 44.188 44.188 0 01-1.998 7.467l-5.491 16.581a10.924 10.924 0 01-2.16 4.274 3.736 3.736 0 01-4.374.959 13.613 13.613 0 00.197-5.5 4.641 4.641 0 00-3.662-3.694c-2.024-.215-3.753 1.354-5.673 2.03a6.979 6.979 0 01-8.811-5.245c-.303-1.895.206-3.925-.513-5.705-.841-2.086-3.074-3.178-4.75-4.677a10.936 10.936 0 01-3.002-11.366c.45-1.38 1.717-2.007 1.464-3.592-.333-2.08-3.4-3.534-5.165-3.942z",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M507 236.5h248v272H507z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M532 210.5h248v272H532z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M556 227.5v208h201"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "#575a89",
  d: "M567 362.5h45v72h-45z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M632 313.5h45v121h-45z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd005",
  d: "M697 256.5h45v178h-45zM553 451.814h13.371v13.371H553z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M572.314 451.814h13.371v13.371h-13.371z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#575a89",
  d: "M591.629 451.814H605v13.371h-13.371z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M703 457.622h52v2.108h-52zM703 463.946h52v2.108h-52zM703 470.27h52v2.108h-52z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M724.308 177.682c10.628.462 18.525 10.1 17.376 20.677-1.042 9.582-4.884 21.505-16.988 26.084-21.567 8.161-20.401-37.888-16.321-39.637 2.72-1.165 6.995-7.512 15.933-7.124z",
  fill: "#ffb9b9"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M999.823 193.254l6.412 3.114s13.99 28.562 14.573 32.643 9.909 19.235 6.411 23.316-8.743 14.572-5.246 18.652 11.658 20.402 11.658 26.23-8.743 21.568-2.914 23.316 4.08 24.482 2.914 26.23-16.32 30.311-16.32 30.311-2.915-32.642-31.477-19.235c0 0-2.332-16.321 0-17.487s8.16-8.16 3.497-9.326-11.075-15.156-9.91-16.904 4.081-4.08 1.167-5.83-5.246-11.657-4.663-13.406-6.412-9.91-6.412-9.91z",
  fill: "#575a89"
});

var SvgAllTheData = function SvgAllTheData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 1120,
    height: 829.801,
    viewBox: "0 0 1120 829.801"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
};

export default __webpack_public_path__ + "static/all_the_data.b0bd97a9.svg";
export { SvgAllTheData as ReactComponent };